import { useState, useEffect, useRef } from 'react'
import { getParkings } from 'store/actions/parkingActions'

const useGetParkings = (id = '') => {
  const mountedRef = useRef(true)
  const [parkings, setParkings] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData(id)
    return () => {
      mountedRef.current = false
    }
  }, [])

  const getData = async (id = '') => {
    setLoading(true)
    try {
      const data = await getParkings(id || '')
      if (!mountedRef.current) return null
      setParkings(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  return { loading, parkings, refetch: () => getData(id) }
}

export default useGetParkings
